import { Component } from '@angular/core';

@Component({
  selector: 'gi-align-container',
  templateUrl: 'align-container.html'
})
export class AlignContainerComponent {

  text: string;

  constructor() {
  }

}



// WEBPACK FOOTER //
// ./src/components/align-container/align-container.ts